import { Guid } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';

export class PublicCosmeticBrand {
  public constructor(
    private readonly data: {
      id: Guid;
      logo: Multimedia;
      name: string;
      slug: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get logo(): Multimedia {
    return this.data.logo;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }
}
